import React from "react";
import NameListManager from "./NameListManager";

export default function SettingsExpenseMarkets() {
  return (
    <NameListManager
      title="Expense markets"
      endpoint="/admin/expense-markets"
      listEndpoint="/expense-markets"
      testidPrefix="expense-market"
      placeholder="e.g. Blinkit"
    />
  );
}
